// stores/useChatStore.ts
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useChatStore = defineStore('chat', () => {
    const roomId = ref<string>('')
    const userId = ref<string | number>('')
    const currentUserId = ref<string | number>('')
    const firebaseConfig = ref<Record<string, any>>({})
    const unreadCount = ref<number>(0)
    const unreadActivityTick = ref<number>(0)

    function init(config: any, ids: { roomId: string; userId: string | number; currentUserId: string | number }) {
        firebaseConfig.value = config
        roomId.value = ids.roomId
        userId.value = ids.userId
        currentUserId.value = ids.currentUserId
    }

    function setUnreadCount(count: number): void {
        const n = Number(count)
        unreadCount.value = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0
    }

    function signalUnreadActivity(): void {
        unreadActivityTick.value += 1
    }

    return {
        roomId,
        userId,
        currentUserId,
        firebaseConfig,
        unreadCount,
        unreadActivityTick,
        init,
        setUnreadCount,
        signalUnreadActivity,
    }
})
